import React from 'react';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';
import ModalSidebar, {
  ModalSidebarContent,
} from '../../../../components/ModalSidebar';
import { useCalibrationWorkspace } from '../CalibrationWorkspaceContext';
import { CalibrationHistory } from './CalibrationHistory';

type Props = {
  employeeTopicId: string | null;
  onClose: () => void;
};

const i18Path = 'performanceReview.calibration.sidePanel';

export const CalibrationSidePanel: React.FC<React.PropsWithChildren<Props>> = ({
  employeeTopicId,
  onClose,
}) => {
  const t = useNamespacedTranslation(i18Path);
  const { session } = useCalibrationWorkspace();

  const employeeTopic = employeeTopicId
    ? session.employeeTopics.find((et) => et.Id === employeeTopicId)
    : undefined;
  const topic = employeeTopic
    ? session.topics.find(
        (tp) => tp.Id === employeeTopic.flair__Calibration_Topic__c,
      )
    : undefined;

  const header = employeeTopic
    ? t('historyTitle', {
        employeeName: employeeTopic.employee.Name,
        topicName: topic?.Name ?? '',
      })
    : t('title');

  return (
    <ModalSidebar
      show={employeeTopicId !== null}
      onClose={onClose}
      header={header}
      content={
        <ModalSidebarContent
          body={
            employeeTopicId ? (
              <CalibrationHistory
                employeeTopicId={employeeTopicId}
                topicType={topic?.flair__Topic_Type__c ?? null}
              />
            ) : null
          }
        />
      }
    />
  );
};
